export default function definePopupClass(Popup) {
	Popup = function(name, position) {
		this.name = name;
		this.position = position;

		var pixelOffset = document.createElement('div');
		pixelOffset.classList.add('popup-bubble-content');
		pixelOffset.textContent = name;

		this.anchor = document.createElement('div');
		this.anchor.classList.add('popup-bubble-anchor');
		this.anchor.appendChild(pixelOffset);

		this.stopEventPropagation();
	};

	Popup.prototype = Object.create(window.google.maps.OverlayView.prototype);

	Popup.prototype.onAdd = function() {
		this.getPanes().floatPane.appendChild(this.anchor);
	};

	Popup.prototype.draw = function() {
		const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

		const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';

		if (display === 'block') {
			this.anchor.style.left = divPosition.x + 'px';
			this.anchor.style.top = divPosition.y + 'px';
		}

		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	};

	Popup.prototype.stopEventPropagation = function() {
		var anchor = this.anchor;
		anchor.style.cursor = 'auto';

		['dblclick', 'contextmenu', 'wheel'].forEach(function(event) {
			anchor.addEventListener(event, function(e) {
				e.stopPropagation();
			});
		});
	};

	return Popup;
}